import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { CreateEventDto, PublicEvent } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const createEvent = async ({
  orgId,
  event,
}: {
  orgId: string;
  event: CreateEventDto;
}) => {
  const response = await axiosClient.post(`${orgId}/events`, event);
  return response.data;
};

export function useCreateEvent(
  queryOptions?: UseMutationOptions<
    PublicEvent,
    HttpError,
    { orgId: string; event: CreateEventDto }
  >,
) {
  return useMutation({
    mutationFn: createEvent,
    ...queryOptions,
  });
}
